import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "slotbooking-tabs status-tabs"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('进口商状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "data-permission": "commodity_importer_cv_status",
      "id": "commodity_importer_cv_status",
      "size": "small",
      "animated": false
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.searchData.cv_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "cv_status", $$v);
      },
      expression: "searchData.cv_status"
    }
  }, [_c('a-tab-pane', {
    key: undefined,
    attrs: {
      "tab": _vm.t('全部 {0}', [_vm.searchData.cv_status === undefined ? _vm.total !== null ? "(" + _vm.total + ")" : '' : ''])
    }
  }), _vm._l(_vm.statusList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": _vm.searchData.cv_status === item.value ? item.text + (_vm.total !== null ? "(" + _vm.total + ")" : '') : item.text
      }
    });
  })], 2)], 1), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "commodity_importer_number_type",
      "id": "commodity_importer_number_type"
    },
    model: {
      value: _vm.searchData.number_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "number_type", $$v);
      },
      expression: "searchData.number_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "vat_number"
    }
  }, [_vm._v(_vm._s(_vm.t('增值税号')))]), _c('a-select-option', {
    attrs: {
      "value": "exemption_number"
    }
  }, [_vm._v(_vm._s(_vm.t('豁免号')))]), _c('a-select-option', {
    attrs: {
      "value": "eori"
    }
  }, [_vm._v(_vm._s(_vm.t('清关税号')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "data-permission": "commodity_importer_number",
      "id": "commodity_importer_number",
      "allowClear": "",
      "maxLength": 100
    },
    model: {
      value: _vm.searchData.number,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "number", $$v);
      },
      expression: "searchData.number"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    attrs: {
      "allow-clear": false,
      "value": "1"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t('公司名称')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "data-permission": "commodity_importer_company_name",
      "id": "commodity_importer_company_name",
      "allowClear": "",
      "maxLength": 50
    },
    model: {
      value: _vm.searchData.company_name,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "company_name", $$v);
      },
      expression: "searchData.company_name"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u4ED3\u5E93"),
      "data-permission": "commodity_importer_warehouse_code",
      "id": "commodity_importer_warehouse_code",
      "placeholder": _vm.t('仓库'),
      "show-tip": "",
      "show-search": "",
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code
    }, [_vm._v(" " + _vm._s(item.warehouse_name_text) + " ")]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u82F1\u56FD/\u6B27\u76DF"),
      "data-permission": "commodity_importer_is_eu",
      "id": "commodity_importer_is_eu",
      "show-tip": "",
      "placeholder": _vm.t('是否英国/欧盟'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.is_eu,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "is_eu", $$v);
      },
      expression: "searchData.is_eu"
    }
  }, _vm._l(_vm.isEuEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u66F4\u65B0\u65F6\u95F4"),
      "allow-clear": false,
      "data-permission": "commodity_importer_search_time_type",
      "id": "commodity_importer_search_time_type",
      "placeholder": _vm.t('更新时间')
    },
    model: {
      value: _vm.searchData.time_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_type", $$v);
      },
      expression: "searchData.time_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "cv_create_time"
    }
  }, [_vm._v(_vm._s(_vm.t('创建时间')))]), _c('a-select-option', {
    attrs: {
      "value": "cv_update_time"
    }
  }, [_vm._v(_vm._s(_vm.t('更新时间')))]), _c('a-select-option', {
    attrs: {
      "value": "auditing_time"
    }
  }, [_vm._v(_vm._s(_vm.t('审核时间')))])], 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "commodity_importer_datetime",
      "id": "commodity_importer_datetime",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "limit-range-day": 0,
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "bottom",
      "display": "inline-block",
      "margin-top": "10px"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-permission": "commodity_importer_search",
      "id": "commodity_importer_search",
      "data-sign": "commodity_importer_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "commodity_importer_reset",
      "data-permission": "commodity_importer_reset",
      "id": "commodity_importer_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mb-15"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'commodity_importer_export',
      expression: "'commodity_importer_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "commodity_importer_export_all",
      "id": "commodity_importer_export_all",
      "data-sign": "commodity_importer_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "commodity_importer_export_selected",
      "id": "commodity_importer_export_selected",
      "data-sign": "commodity_importer_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'commodity_importer_add',
      expression: "'commodity_importer_add'"
    }],
    staticClass: "fr",
    attrs: {
      "data-permission": "commodity_importer_add",
      "id": "commodity_importer_add",
      "data-sign": "'commodity_importer_add'",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.t('新增')))])], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "useMouseTool": "",
      "data-sign": "commondity_importer_list",
      "fixed-header": "",
      "is-filter-box": "",
      "name": "commodityImporterList",
      "data-source": _vm.dataList,
      "row-selection": {
        selectedRowKeys: _vm.selectedList,
        onChange: _vm.onSelectChange
      },
      "row-key": "cv_id",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "companyName",
      fn: function (ref) {
        var record = ref.record;
        return [record['company_name'] ? _c('div', [_c('a', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record['company_name'],
            expression: "record['company_name']"
          }],
          attrs: {
            "data-sign": "commodity_importer_company_info"
          },
          on: {
            "click": function ($event) {
              return _vm.showDetail(record);
            }
          }
        }, [_vm._v(" " + _vm._s(record['company_name']) + " ")]), record.is_eu ? _c('div', [_vm._v(_vm._s(_vm._f("companyType")(record, _vm.$enum.warehouse, _vm.t)))]) : _vm._e()]) : _c('span', [_vm._v("--")])];
      }
    }, {
      key: "warehouse",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record['warehouse_code'] ? _c('span', [_vm._v(_vm._s(record['warehouse_code']))]) : _vm._e(), record['warehouse_name'] ? _c('span', [_vm._v("[" + _vm._s(record['warehouse_name']) + "]")]) : _vm._e()]);
      }
    }, {
      key: "vat",
      fn: function (ref) {
        var record = ref.record;
        return [record['warehouse_code'] === _vm.$enum.warehouse.importWarehouseCode.FRVI ? _c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.vat_number || record.exemption_number,
            expression: "record.vat_number || record.exemption_number"
          }]
        }, [_vm._v(_vm._s(_vm._f("filterEmpty/--")(record['vat_number'] || record['exemption_number'])))]) : _c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.vat_number || record.exemption_number,
            expression: "record.vat_number || record.exemption_number"
          }]
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record['vat_number'])) + "/" + _vm._s(_vm._f("filterEmpty")(record['exemption_number'])))])];
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(_vm.t('创建')) + ": " + _vm._s(_vm._f("filterEmpty")(record['cv_create_time'])))]), _c('div', [_vm._v(_vm._s(_vm.t('审核')) + ": " + _vm._s(_vm._f("filterEmpty")(record['auditing_time'])))]), _c('div', [_vm._v(_vm._s(_vm.t('更新')) + ": " + _vm._s(_vm._f("filterEmpty")(record['cv_update_time'])))])]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [0 === record['cv_status'] ? [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'commodity_importer_copy',
            expression: "'commodity_importer_copy'"
          }],
          attrs: {
            "data-permission": "commodity_importer_copy",
            "id": "commodity_importer_copy",
            "data-sign": "commodity_importer_copy",
            "fbu-analyse-name": $t("\u590D\u5236")
          },
          on: {
            "click": function ($event) {
              return _vm.handleUpdate(record, true);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('复制')))])] : 2 === record['cv_status'] ? [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'commodity_importer_discard',
            expression: "'commodity_importer_discard'"
          }],
          attrs: {
            "data-permission": "commodity_importer_abandon",
            "id": "commodity_importer_abandon",
            "data-sign": "commodity_importer_discard",
            "fbu-analyse-name": $t("\u5E9F\u5F03")
          },
          on: {
            "click": function ($event) {
              return _vm.cancelBulkImporter(record['cv_id']);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('废弃')))])] : 3 === record['cv_status'] ? [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'commodity_importer_edit',
            expression: "'commodity_importer_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "commodity_importer_edit",
            "id": "commodity_importer_edit",
            "data-sign": "commodity_importer_edit",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleUpdate(record, false);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]), _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'commodity_importer_delete',
            expression: "'commodity_importer_delete'"
          }],
          attrs: {
            "data-permission": "commodity_importer_delete",
            "id": "commodity_importer_delete",
            "data-sign": "commodity_importer_delete",
            "fbu-analyse-name": $t("\u5220\u9664")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDeleteBulkImporter(record['cv_id']);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('删除')))])] : _vm._e()], 2);
      }
    }, {
      key: "cv_status_text",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(record.cv_status_text)) + " "), record.cv_status === _vm.$enum.warehouse.cvStatus.dismissed && record.reject_content ? _c('a-tooltip', [_c('span', {
          attrs: {
            "slot": "title"
          },
          slot: "title"
        }, [_vm._v(_vm._s(record.reject_content))]), _c('a-icon', {
          style: {
            fontsize: '18px',
            color: '#FF7E00'
          },
          attrs: {
            "type": "exclamation-circle",
            "theme": "filled"
          }
        })], 1) : _vm._e()], 1);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "name": "commodityImporterList",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };